import React from 'react';
import MeterProductPage from '../meter-product-page';

import bgImg from '../../../assets/product-interaction/ddsu5168/ddsu5168_background.png';
import logoImg from '../../../assets/product-interaction/ddsu5168/ddsu5168_logo_white.png';
import qrImg from '../../../assets/product-interaction/ddsu5168/ddsu5168_qr_code.jpg';
import productImg from '../../../assets/product-interaction/dtsu5168/dtsu5168_direct.png';

// 临时复用 2P 说明书编号，产品说明书确认后只需替换此地址。
const MANUAL_URL = 'http://m.joymeter.com/manual?code=DTSU5168-700-007';

const DTSU5168 = () => (
  <MeterProductPage
    documentTitle="DTSU5168｜三相导轨式电能表（7P）"
    bgImg={bgImg}
    logoImg={logoImg}
    productImg={productImg}
    qrImg={qrImg}
    model="DTSU5168"
    productName="三相导轨式电能表（7P）"
    slogan="三相计量 · 稳定可靠"
    tags={['RS485', '直接式', '互感式']}
    manualUrl={MANUAL_URL}
    wiringUrl="/product/dtsu5168/wiring"
  />
);

export default DTSU5168;
